import { ScheduleOfValuesResponseDto } from 'libs/pinnacle-sdk';
import { ScheduleOfValue } from './types';
import { isNumber, isString } from 'lodash';

export function parseNumericFields(
  sov: ScheduleOfValuesResponseDto
): ScheduleOfValue {
  const result: ScheduleOfValue = {
    // Map all properties from input DTO to output type
    // Type-cast all fields and handle numeric conversion
    locationNumber: parseNumberOrKeepOriginal(sov.locationNumber),
    property: sov.property,
    streetAddress: sov.streetAddress,
    suburb: sov.suburb,
    state: sov.state,
    postalZipCode: sov.postalZipCode,
    pdDeductibles: parseNumberOrKeepOriginal(sov.pdDeductibles),
    biValue: parseNumberOrKeepOriginal(sov.biValue),
    buildingValue: parseNumberOrKeepOriginal(sov.buildingValue),
    cpe: parseNumberOrKeepOriginal(sov.cpe),
    stock: parseNumberOrKeepOriginal(sov.stock),
    latitude: parseNumberOrKeepOriginal(sov.latitude),
    longitude: parseNumberOrKeepOriginal(sov.longitude),
    constructionClass: sov.constructionClass,
    roofType: sov.roofType,
    numberOfStories: parseNumberOrKeepOriginal(sov.numberOfStories),
    yearBuilt: parseNumberOrKeepOriginal(sov.yearBuilt),
    fluvialFlood: sov.fluvialFlood,
    originalStormSurge: sov.originalStormSurge,
    originalPfRiskLevel: sov.originalPfRiskLevel,
    windstorm: sov.windstorm,
    hailstorm: sov.hailstorm,
    wildfire: sov.wildfire,
    crestaZone: sov.crestaZone,
    country: sov.country,
    occupancy: sov.occupancy,
    pdValue: parseNumberOrKeepOriginal(sov.pdValue) ?? 0, // Required field
    totalInsurableValue:
      parseNumberOrKeepOriginal(sov.totalInsurableValue) ?? 0, // Required field
    sovId: sov.sovId,
    submissionId: sov.submissionId,
    fileId: sov.fileId,
  };

  return result;
}

function parseNumberOrKeepOriginal(value: unknown): number | undefined {
  if (value === undefined || value === null) {
    return undefined;
  }

  if (isNumber(value)) {
    return value;
  }

  if (isString(value)) {
    const parsed = parseFloat(value);
    return !isNaN(parsed) ? parsed : undefined;
  }

  return undefined;
}

export function parseNumericFieldsArray(
  sovs: ScheduleOfValuesResponseDto[] | undefined
): ScheduleOfValue[] | undefined {
  if (!sovs) return undefined;
  return sovs.map(parseNumericFields);
}

export function cleanStringField(value: unknown): string | undefined {
  return value && String(value).trim() !== ''
    ? String(value).trim()
    : undefined;
}
